import type { ReactNode } from 'react';
import { useSetPageHeader } from '@/layout/PageHeaderContext';

/**
 * Publishes the page's title + subtitle to the Topbar (see PageHeaderContext)
 * and renders only the action buttons in place. The old duplicated
 * in-page heading is gone — the Topbar is the single visible source.
 */
export function SectionHeader({
  title,
  subtitle,
  actions,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
}) {
  useSetPageHeader(title, subtitle);
  if (!actions) return null;
  return (
    <div className="mb-2 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-end sm:gap-4">
      <div className="flex flex-col gap-2 sm:flex-row [&>*]:w-full [&>*]:justify-center sm:[&>*]:w-auto sm:[&>*]:justify-start">
        {actions}
      </div>
    </div>
  );
}
